import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { BankAccountService } from '../bancos/bankaccount.service';
import { MovimientoBancoPolizaCredito, PolizaCredito } from '../../../models/finanzas/poliza-credito/poliza-credito.model';
import { PolizaCreditoListComponent } from './poliza-credito-list.component';
import { PolizaCreditoService } from '../../../services/finanzas/poliza-credito/poliza-credito.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { consts } from '../../../consts';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActualSelected } from '../../../shared/utils';

@Component({
    selector: 'convfact-poliza-credito-movimiento-banco',
    templateUrl: './poliza-credito-dialog-movimiento-banco.component.html',
    styleUrls: ['./poliza-credito.component.css'],
    standalone: false
})
export class PolizaCreditoDialogMovimientoBancoComponent implements OnInit {

  public polizaCredito: PolizaCredito = this.data.polizaCredito;

  public tipoMovimientoBancoId: number = this.data.tipoMovimientoBancoId;

 public movimientoBanco: MovimientoBancoPolizaCredito = {
  uid: '',
  polizaCreditoId: '0',
  bankAccountsUid: '',
  tiposMovimientoBancoId: this.tipoMovimientoBancoId,
  fecha: new Date(),
  comisiones: 0,
  concepto: '',
  importe: 0,
  bankAccountInfo: '0',
  activitiesUid: consts.EMPTY_GUID,
  activitiesName: '',
  projectUid: consts.EMPTY_GUID,
  expenseProjectTypeUid: consts.EMPTY_GUID,
};


  public tittle: string = 'Elemento';

  public saved: boolean = false;

  public ready: boolean = false;

  public isEditMode: boolean = false;

  public list: boolean = false;

  public bankAccounts: BankAccountModel[] = [];

  private changesAtModal: boolean = false;

  public dataSource: MovimientoBancoPolizaCredito[] = [];
  public headerTable: any[] = [
    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },
    { field: 'concepto', title: 'Concepto', cell: (row) => `${row.concepto}  `, class: (row) => `` },
    { field: 'importe', title: 'Importe', cell: (row) => `${row.importe}  `, class: (row) => `` },
    { field: 'bankAccountInfo', title: 'Banco / Tarjeta', cell: (row) => row.bankAccountInfo ? `${row.bankAccountInfo}` : '', class: (row) => `` },
  ];

  public activities: ActivityModel[] = [];

  projects: MasterModel[] = [];
  expenseProjectTypes: MasterModel[] = [];
  isProjectEnable: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PolizaCreditoListComponent>,
    public polizaCreditoService: PolizaCreditoService,
    public bankAccountService: BankAccountService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public activityService: ActivityService,
    private cdr: ChangeDetectorRef,
    private masterService: MasterService,
  ) { }

  public ngOnInit(): void {
    this.activityService.getList()
      .then(response => {
        this.activities = response;
      });

      this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
            this.isProjectEnable = activity.isProject;
          });
    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
      });

    if (this.tipoMovimientoBancoId === 1) {
      this.tittle = "Traspaso";
    } else if (this.tipoMovimientoBancoId === 2) {
      this.tittle = "Transferencia";
    }
    //Projects

    this.masterService.getProjects().subscribe(data => {
      this.projects = data;
      this.cdr.detectChanges();
    })

    //Expense Project Types
    this.masterService.getExpenseProjectTypes().subscribe(data => {
      this.expenseProjectTypes = data;
      this.cdr.detectChanges();
    })

    this.getData();
  }

  public save(): void {
    this.movimientoBanco.polizaCreditoId = this.polizaCredito.uid;

    let noError: boolean = true;

    if (!this.movimientoBanco.fecha ||
      !this.movimientoBanco.concepto ||
      !this.movimientoBanco.importe ||
      !this.movimientoBanco.activitiesUid) {
      noError = false;
    }

    if (!noError) {
      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
      return;
    }

    // 👇 Aseguramos que los valores de project y expense se mandan como GUIDs
    if (this.movimientoBanco.projectUid === null || this.movimientoBanco.projectUid === undefined) {
      this.movimientoBanco.projectUid = consts.EMPTY_GUID;
    }

    if (this.movimientoBanco.expenseProjectTypeUid === null || this.movimientoBanco.expenseProjectTypeUid === undefined) {
      this.movimientoBanco.expenseProjectTypeUid = consts.EMPTY_GUID;
    }

    const request = this.isEditMode
      ? this.polizaCreditoService.movimientoBancoPolizaCreditoUpdate(this.movimientoBanco)
      : this.polizaCreditoService.movimientoBancoPolizaCreditoCreate(this.movimientoBanco);

    request
      .then(() => this.saved = true)
      .catch(() => this.displayInfo("Ha ocurrido un error al guardar el movimiento"));
  }



  public getData(): void {
    this.saved = false;
    this.ready = false;

    this.polizaCreditoService.movimientoBancoPolizaCreditoList(this.polizaCredito.uid, this.tipoMovimientoBancoId)
      .then(response => {
        this.dataSource = response;

        if (this.dataSource.length > 0) {
          this.list = true;
        }
        this.ready = true;
      })
      .catch(error => {
        this.ready = true;
      });
  }

  public delete(uidElement: string): void {
    this.changesAtModal = true;

    // Este uid es el id
    this.polizaCreditoService.movimientoBancoPolizaCreditoDelete(uidElement)
      .then(response => {
        this.getData();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al eliminar");
      });
  }

  public edit(uidElement: string): void {
    const elementSearched = this.dataSource.find(f => f.uid === uidElement);

    if (!elementSearched) return;

    this.isEditMode = true;
    this.saved = false;

    this.movimientoBanco = { ...elementSearched };

    if (elementSearched.projectUid) {
      const projectFound = this.projects.find(p => p.id === elementSearched.projectUid);
      this.movimientoBanco.projectUid = projectFound ? projectFound.id : null;
    }

    if (elementSearched.expenseProjectTypeUid) {
      const expenseFound = this.expenseProjectTypes.find(e => e.id === elementSearched.expenseProjectTypeUid);
      this.movimientoBanco.expenseProjectTypeUid = expenseFound ? expenseFound.id : null;
    }
  }


  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close(this.changesAtModal);
  }
  public trackByIndex(i: number) { return i; }

}
